var map = {
	"./about_advantage1.svg": "d30b",
	"./about_advantage2.svg": "24b5",
	"./about_advantage3.svg": "381f",
	"./about_advantage4.svg": "e838",
	"./about_advantage5.svg": "c873",
	"./check_advantage_svg1.svg": "59d8",
	"./check_advantage_svg2.svg": "e391",
	"./check_advantage_svg3.svg": "bb31",
	"./check_advantage_svg4.svg": "84a4",
	"./check_fun_pic1.svg": "d968",
	"./check_fun_pic2.svg": "7e52",
	"./check_fun_pic3.svg": "52e6f",
	"./check_fun_pic4.svg": "43e7",
	"./check_fun_svg1.svg": "ea3c",
	"./check_fun_svg2.svg": "4da8",
	"./check_fun_svg3.svg": "c49b",
	"./check_fun_svg4.svg": "f9d3",
	"./check_fun_svgOn1.svg": "8fba",
	"./check_fun_svgOn2.svg": "976d",
	"./check_fun_svgOn3.svg": "e105",
	"./check_fun_svgOn4.svg": "507c",
	"./educat_advantage_pic1.svg": "afdd",
	"./educat_advantage_svg1.svg": "0264",
	"./educat_advantage_svg2.svg": "6ecb",
	"./educat_advantage_svgOn1.svg": "bb00",
	"./educat_advantage_svgOn2.svg": "9520",
	"./educat_fun_svg1.svg": "de00",
	"./educat_fun_svg2.svg": "5f03",
	"./educat_fun_svg3.svg": "d136",
	"./erp_advantage_pic1.svg": "0291",
	"./erp_advantage_pic2.svg": "9de5",
	"./erp_advantage_pic3.svg": "26e6",
	"./erp_advantage_svg1.svg": "d89e",
	"./erp_advantage_svg2.svg": "03f5",
	"./erp_advantage_svg3.svg": "b43c",
	"./erp_advantage_svgOn1.svg": "7e2c",
	"./erp_advantage_svgOn2.svg": "721e",
	"./erp_advantage_svgOn3.svg": "cd61",
	"./erp_fun_svg1.svg": "5503",
	"./erp_fun_svg2.svg": "5000",
	"./erp_fun_svg3.svg": "f0e4",
	"./health_advantage1.svg": "ee99",
	"./health_advantage2.svg": "d9ec",
	"./health_advantage3.svg": "ef1e",
	"./health_fun_svg1.svg": "0225",
	"./health_fun_svg2.svg": "85ca",
	"./health_fun_svg3.svg": "8413",
	"./icon_arrow_right.svg": "03fc",
	"./icon_arrow_right1.svg": "f43f",
	"./icon_contact_rocket.svg": "c6f9",
	"./icon_contact_tel.svg": "b115",
	"./icon_hide_arrow.svg": "b875",
	"./icon_hide_close.svg": "35b5",
	"./icon_hide_logo.svg": "e91d",
	"./icon_link.svg": "0fb2",
	"./icon_logo.svg": "0233",
	"./icon_logo_footer.svg": "fbb0",
	"./icon_mobile_fixed1.svg": "4529",
	"./icon_mobile_fixed2.svg": "dd18",
	"./icon_success.svg": "e3bb",
	"./icon_tel.svg": "cf2f",
	"./icon_toggle.svg": "8c1f",
	"./index_system1.svg": "2afe",
	"./index_system10.svg": "e78b",
	"./index_system11.svg": "ace8",
	"./index_system12.svg": "87c3",
	"./index_system13.svg": "3011",
	"./index_system14.svg": "7eef",
	"./index_system15.svg": "a393",
	"./index_system16.svg": "4cca",
	"./index_system17.svg": "6fb0",
	"./index_system18.svg": "e606",
	"./index_system19.svg": "7012",
	"./index_system2.svg": "d50f",
	"./index_system20.svg": "5a0d",
	"./index_system21.svg": "dc70",
	"./index_system22.svg": "bfc2",
	"./index_system23.svg": "5dc5",
	"./index_system24.svg": "d495",
	"./index_system25.svg": "160d",
	"./index_system26.svg": "c0d8",
	"./index_system27.svg": "22c3",
	"./index_system28.svg": "c776",
	"./index_system29.svg": "11c1",
	"./index_system3.svg": "6620",
	"./index_system4.svg": "847d",
	"./index_system5.svg": "9e9d",
	"./index_system6.svg": "5477",
	"./index_system7.svg": "064d",
	"./index_system8.svg": "1ef4",
	"./index_system9.svg": "49aa",
	"./member_advantage1.svg": "9154",
	"./member_advantage2.svg": "131f",
	"./member_advantage3.svg": "0aad",
	"./member_fun_svg1.svg": "ebc8",
	"./member_fun_svg2.svg": "595a",
	"./member_fun_svg3.svg": "b2b5",
	"./member_fun_svg4.svg": "8c5a",
	"./ncd_advantage_pic1.svg": "6394",
	"./ncd_advantage_pic2.svg": "ee8a",
	"./ncd_advantage_pic3.svg": "a183",
	"./ncd_advantage_svg1.svg": "e9bf",
	"./ncd_advantage_svg2.svg": "0dbf",
	"./ncd_advantage_svg3.svg": "5696",
	"./ncd_advantage_svgOn1.svg": "6e61",
	"./ncd_advantage_svgOn2.svg": "fd1b",
	"./ncd_advantage_svgOn3.svg": "e220",
	"./ncd_fun_svg1.svg": "5014",
	"./ncd_fun_svg2.svg": "f60d",
	"./ncd_fun_svg3.svg": "0ab1",
	"./ncd_fun_svg4.svg": "52b5",
	"./service_bg.svg": "6ba7",
	"./service_mechanism1.svg": "58e9",
	"./service_mechanism2.svg": "5d82",
	"./service_mechanism3.svg": "d897",
	"./service_mechanism4.svg": "2b0a",
	"./solve_svg1.svg": "8dc7",
	"./solve_svg2.svg": "b72d",
	"./solve_svg3.svg": "2db8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";